const DEFAULT_BRAND_NAME = '晋辉智机通'
const DEFAULT_THEME = '#f4f5fa'
/** 平台超管租户码（租户后台登录页不应预填） */
const PLATFORM_TENANT_CODE = 'platform'
/** 平台超管顶栏/登录页副标题 */
const PLATFORM_ADMIN_REMARK = '平台管理后台'

const HEADER_NAME_KEY = 'adminHeaderSystemName'
const HEADER_LOGO_KEY = 'adminHeaderLogoUrl'
const HEADER_REMARK_KEY = 'adminHeaderBrandRemark'

/** 推荐后台背景色（首项为系统默认） */
const RECOMMENDED_THEME_COLORS = [
  { name: '系统默认', value: '#f4f5fa' },
  { name: '浅蓝灰', value: '#e8ecf4' },
  { name: '云白蓝', value: '#eef4fc' },
  { name: '暖浅灰', value: '#f5f6f8' },
  { name: '淡青灰', value: '#f0f4f5' },
  { name: '雪青白', value: '#f7f8fc' },
  { name: '雾白', value: '#fafafa' },
  { name: '石板灰', value: '#ecf0f3' },
  { name: '淡天蓝', value: '#e6eef8' },
  { name: '浅雾蓝', value: '#edf2f7' },
  { name: '米白暖', value: '#f5f0eb' },
  { name: '薄荷灰', value: '#eef5f3' },
  { name: '珍珠白', value: '#f8f9fb' },
  { name: '静蓝灰', value: '#e9edf2' },
]

function normalizeThemeColor(color) {
  if (color == null || color === '') {
    return DEFAULT_THEME
  }
  const trimmed = String(color).trim()
  if (!trimmed) {
    return DEFAULT_THEME
  }
  return trimmed.startsWith('#') ? trimmed : `#${trimmed}`
}

export function getBackendThemeColor() {
  return normalizeThemeColor(localStorage.getItem('backendThemeColor'))
}

/** 读取仅用于登录后右侧顶栏的品牌信息 */
export function getAdminHeaderBrand() {
  let backendSystemName = localStorage.getItem(HEADER_NAME_KEY) || ''
  let backendLogoUrl = localStorage.getItem(HEADER_LOGO_KEY) || ''
  let backendBrandRemark = localStorage.getItem(HEADER_REMARK_KEY) || ''
  if (!backendSystemName && localStorage.getItem('backendSystemName')) {
    backendSystemName = localStorage.getItem('backendSystemName') || ''
    localStorage.setItem(HEADER_NAME_KEY, backendSystemName)
    localStorage.removeItem('backendSystemName')
  }
  if (!backendLogoUrl && localStorage.getItem('backendLogoUrl')) {
    backendLogoUrl = localStorage.getItem('backendLogoUrl') || ''
    localStorage.setItem(HEADER_LOGO_KEY, backendLogoUrl)
    localStorage.removeItem('backendLogoUrl')
  }
  if (!backendBrandRemark && localStorage.getItem('backendBrandRemark')) {
    backendBrandRemark = localStorage.getItem('backendBrandRemark') || ''
    localStorage.setItem(HEADER_REMARK_KEY, backendBrandRemark)
    localStorage.removeItem('backendBrandRemark')
  }
  return { backendSystemName, backendLogoUrl, backendBrandRemark }
}

function dispatchHeaderBrandChange(detail = {}) {
  const brand = getAdminHeaderBrand()
  window.dispatchEvent(
    new CustomEvent('backend-header-brand-change', {
      detail: {
        backendSystemName: brand.backendSystemName,
        backendLogoUrl: brand.backendLogoUrl,
        backendBrandRemark: brand.backendBrandRemark,
        backendThemeColor: getBackendThemeColor(),
        ...detail,
      },
    })
  )
}

/** 应用后台主题色：顶栏固定白底，主题色仅作用于内容画布 */
export function applyBackendThemeColor(color) {
  const theme = normalizeThemeColor(color)
  document.documentElement.style.setProperty('--tenant-admin-header-bg', '#ffffff')
  document.documentElement.style.setProperty('--tenant-admin-page-bg', theme)
  document.documentElement.style.setProperty('--admin-page-bg', theme)
  document.documentElement.style.setProperty('--admin-canvas-bg', theme)
  localStorage.setItem('backendThemeColor', theme)
  dispatchHeaderBrandChange({ backendThemeColor: theme })
  return theme
}

/** 同步并广播顶栏品牌（名称、Logo、备注），不影响登录页与侧栏 */
export function applyBackendBranding(data = {}) {
  if (data.backendSystemName != null) {
    localStorage.setItem(HEADER_NAME_KEY, data.backendSystemName || '')
  }
  if (data.backendLogoUrl != null) {
    localStorage.setItem(HEADER_LOGO_KEY, data.backendLogoUrl || '')
  }
  if (data.backendBrandRemark != null) {
    localStorage.setItem(HEADER_REMARK_KEY, data.backendBrandRemark || '')
  }
  let theme = getBackendThemeColor()
  if (data.backendThemeColor != null) {
    theme = applyBackendThemeColor(data.backendThemeColor)
  } else {
    dispatchHeaderBrandChange()
  }
  return theme
}

export function saveTenantBranding(data = {}) {
  applyBackendBranding({
    backendSystemName: data.backendSystemName || '',
    backendLogoUrl: data.backendLogoUrl || '',
    backendBrandRemark: data.backendBrandRemark || '',
    backendThemeColor: data.backendThemeColor || DEFAULT_THEME,
  })
}

export function clearAdminHeaderBrand() {
  localStorage.removeItem(HEADER_NAME_KEY)
  localStorage.removeItem(HEADER_LOGO_KEY)
  localStorage.removeItem(HEADER_REMARK_KEY)
  localStorage.removeItem('backendSystemName')
  localStorage.removeItem('backendLogoUrl')
  localStorage.removeItem('backendBrandRemark')
  localStorage.removeItem('backendThemeColor')
}

/** 平台超管登录后顶栏固定展示「晋辉智机通」 */
export function applyPlatformAdminBranding() {
  applyBackendBranding({
    backendSystemName: DEFAULT_BRAND_NAME,
    backendBrandRemark: PLATFORM_ADMIN_REMARK,
    backendThemeColor: DEFAULT_THEME,
  })
}

export function getSavedTenantCode() {
  const fromPortal = (localStorage.getItem('tenantAdmin:tenantCode') || '').trim()
  if (fromPortal) {
    return fromPortal
  }
  return (localStorage.getItem('tenantCode') || '').trim()
}

/** 租户后台登录页初始租户码：不回填 platform，其余沿用上次租户登录记录 */
export function getTenantLoginTenantCode() {
  const saved = getSavedTenantCode()
  if (!saved || saved.toLowerCase() === PLATFORM_TENANT_CODE) {
    return ''
  }
  return saved
}

export function isSavedTenantCode(code) {
  const saved = getSavedTenantCode()
  const current = (code || '').trim()
  if (!saved || !current) {
    return false
  }
  return saved.toLowerCase() === current.toLowerCase()
}

export { DEFAULT_BRAND_NAME, DEFAULT_THEME, PLATFORM_ADMIN_REMARK, PLATFORM_TENANT_CODE, RECOMMENDED_THEME_COLORS, normalizeThemeColor }
